exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {\n    background: white;\n    width: 100%;\n    position: fixed;\n    z-index: 10000000;\n    bottom: 0;\n    top: 0;\n}\n\n.loader-gif {\n    width: 15%;\n    padding-top: 5px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.loader-pad {\n    padding-top: 15%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src185846418/src/src/app/loader/loader.component.css
// module id = ../../../../../src/app/loader/loader.component.css
// module chunks = main